import { AfterViewInit, Directive, ElementRef, OnDestroy, inject } from '@angular/core';

const FOCUSABLE_SELECTORS =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

@Directive({
  standalone: true,
  selector: '[abxDialogFocus]',
})
export class DialogFocusDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef<HTMLElement>);
  private previouslyFocused: HTMLElement | null = null;

  ngAfterViewInit(): void {
    this.previouslyFocused = document.activeElement as HTMLElement;
    const firstFocusable = this.el.nativeElement.querySelector(FOCUSABLE_SELECTORS) as HTMLElement | null;
    if (firstFocusable) {
      firstFocusable.focus();
    } else {
      this.el.nativeElement.focus();
    }
  }

  ngOnDestroy(): void {
    if (this.previouslyFocused && typeof this.previouslyFocused.focus === 'function') {
      this.previouslyFocused.focus();
    }
  }
}
